import { getI18n } from 'react-i18next';

export default (shortName) => {
    const i18n = getI18n();
    const intlRegionParser = new Intl.DisplayNames([i18n.language], { type: 'language', languageDisplay: 'standard' });
    return intlRegionParser.of(shortName);
}